import * as React from 'react';
const SvgIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M560-253.85 333.85-480 560-706.15 602.15-664l-184 184 184 184z"></path>
  </svg>;
export default React.memo(SvgIcon);